import Money from 'big.js';

/*
 * Returns true if value is 0.
 *
 */
Money.prototype.isZero = function() {
  return this.eq(0)
};

/*
 * Returns true if value is not 0.
 *
 */
Money.prototype.isNotZero = function() {
  return !this.isZero();
};

/*
 * Returns a 2 decimal number..
 *
 */
Money.prototype.toNumber = function() {
  return Number(this.toFixed(2));
};


export default Money;
